import { disputeProductStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-overview-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDisputeProductStats = {
  name: "getDisputeProductStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: disputeProductStatsSchema,
};
